import api from './api';

export const profileService = {
  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await api.put('/auth/change-password', { currentPassword, newPassword });
  },

  async uploadAvatar(image: string): Promise<string> {
    const response = await api.put('/users/me/avatar', { image });
    return response.data.data.avatar;
  },

  async removeAvatar(): Promise<void> {
    await api.delete('/users/me/avatar');
  },

  async setUsername(username: string): Promise<string> {
    const response = await api.put('/users/me/username', { username });
    return response.data.data.username;
  },

  async setupTwoFactor(): Promise<{ qrCodeDataUrl: string; manualEntryKey: string }> {
    const response = await api.post('/auth/2fa/setup');
    return response.data.data;
  },

  async enableTwoFactor(code: string): Promise<{ recoveryCodes: string[]; twoFactorRecoveryCodesRemaining: number }> {
    const response = await api.post('/auth/2fa/enable', { code });
    return response.data.data;
  },

  async disableTwoFactor(code: string): Promise<void> {
    await api.post('/auth/2fa/disable', { code });
  },

  async regenerateRecoveryCodes(code: string): Promise<{ recoveryCodes: string[]; twoFactorRecoveryCodesRemaining: number }> {
    const response = await api.post('/auth/2fa/recovery/regenerate', { code });
    return response.data.data;
  },

  async updateNotificationSettings(settings: {
    notifyEmail?: boolean;
    notifyBrowser?: boolean;
    notifySound?: boolean;
  }): Promise<{ notifyEmail: boolean; notifyBrowser: boolean; notifySound: boolean }> {
    const response = await api.put('/users/me/notification-settings', settings);
    return response.data.data;
  },

  async updateTimezone(settings: {
    timezone?: string;
    timezoneAuto: boolean;
  }): Promise<{ timezone: string; timezoneAuto: boolean }> {
    const response = await api.put('/users/me/timezone', settings);
    return response.data.data;
  }
};
